type DesignImageSource = {
	thumbnail?: string;
	metadata?: { canonicalRenderingPath?: string } | null;
} | null | undefined;

/**
 * The design's display image, used everywhere (design list, blueprint view, estimate, HubSpot):
 * the inline base64 thumbnail first, falling back to a legacy rendering blob URL on older designs.
 */
export const getDesignImage = (blueprint: DesignImageSource): string =>
	blueprint?.thumbnail || blueprint?.metadata?.canonicalRenderingPath || '';
